"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DatePicker;

var _react = _interopRequireWildcard(require("react"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _dateFns = require("date-fns");

var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _Container = _interopRequireDefault(require("./Container"));

var _DatePicker = require("./DatePicker.styled");

var _Header = _interopRequireDefault(require("./Header"));

var _date = require("../../../../helpers/date");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// NOTE: We are registering and setting the `en-GB` locale as default
// to have weeks start on a Monday in the calendar UI.
(0, _reactDatepicker.registerLocale)('en-GB', _enGB["default"]);
(0, _reactDatepicker.setDefaultLocale)('en-GB'); // NOTE: We are using a custom input for the date picker to pass down
// custom props such as `data-testid`.

var CustomDatePickerInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return __jsx(_DatePicker.Input, (0, _extends2["default"])({
    type: "text",
    ref: ref
  }, props));
});
CustomDatePickerInput.displayName = 'CustomDatePickerInputRef';

function DatePicker(_ref) {
  var maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      onChange = _ref.onChange,
      selected = _ref.selected,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["maxDate", "minDate", "onChange", "selected"]);
  var dates = {
    max: (0, _date.makeDateFromInput)(maxDate),
    min: (0, _date.makeDateFromInput)(minDate),
    selected: (0, _date.makeDateFromInput)(selected)
  };

  var _useState = (0, _react.useState)(dates.selected),
      selectedValue = _useState[0],
      setSelectedValue = _useState[1];

  var customHeader = function customHeader(customHeaderProps) {
    var extendedCustomHeaderProps = _objectSpread(_objectSpread({}, customHeaderProps), {}, {
      minDate: dates.min,
      maxDate: dates.max
    });

    return __jsx(_Header["default"], extendedCustomHeaderProps);
  };

  var handleChange = function handleChange(date) {
    var dateValue = date === null ? '' : date;
    var formattedDate = dateValue && (0, _dateFns.format)(dateValue, props.dateFormat);
    setSelectedValue(dateValue);
    if (onChange) onChange(formattedDate);
  };

  var handleChangeRaw = function handleChangeRaw(event) {
    // NOTE: We are using `event.preventDefault()` here because otherwise, when used
    // inside a label, the date picker will not close after selecting a date.
    var isDayButton = event.target.classList.contains('react-datepicker__day');
    if (isDayButton) event.preventDefault();
  };

  return __jsx(_DatePicker.Wrapper, null, __jsx(_reactDatepicker["default"], (0, _extends2["default"])({
    calendarContainer: _Container["default"],
    customInput: __jsx(CustomDatePickerInput, props),
    inputMode: "decimal",
    maxDate: dates.max,
    minDate: dates.min,
    onChange: handleChange,
    onChangeRaw: handleChangeRaw,
    popperPlacement: "bottom-start",
    renderCustomHeader: customHeader,
    selected: selectedValue
  }, props)), __jsx(_DatePicker.Icon, null));
}

DatePicker.defaultProps = {
  dateFormat: 'yyyy-MM-dd',
  maxDate: new Date(9999, 11, 31, 0, 0, 0),
  minDate: new Date(1900, 0, 1, 0, 0, 0),
  selected: null
};